<template>
    <div class="DateTimePickerTime">
        <div class="DateTimePickerTime__content">
            <div @click="previousTime()" class="DateTimePickerTime__icon" v-bind:class="{'DateTimePickerTime__icon_disabled':index<=0}">
                <i class="icon-left-open-1"></i>
            </div>
            <div class="DateTimePickerTime__title">
                {{title}}
            </div>
            <div @click="nextTime()" class="DateTimePickerTime__icon" v-bind:class="{'DateTimePickerTime__icon_disabled':index>=length-1}">
                <i class="icon-right-open-1"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'DateTimePickerTime',
        computed: {
            ...mapState({
                title: s => s.dateTimePicker.time != null ? s.dateTimePicker.time.title : null,
                index: s => s.dateTimePicker.time != null ? s.dateTimePicker.time.index : null,
                length: s => s.dateTimePicker.times.length
            })
        },
        methods: {
            ...mapActions({
                nextTime: 'dateTimePicker/nextTime',
                previousTime: 'dateTimePicker/previousTime'
            })
        }
    };
</script>

<style>
    .DateTimePickerTime {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 4px 0 12px 0;
        color: #000;
        margin: 0;
        line-height: 2rem;
    }

    .DateTimePickerTime__content {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        max-width: 250px;
    }

    .DateTimePickerTime__title {
        text-align: center;
        font-size: 1.8rem;
    }

    .DateTimePickerTime__icon {
        font-size: 24px;
        background-color: transparent;
        cursor: pointer;
        color: #757575
    }

    .DateTimePickerTime__icon_disabled {
        pointer-events: none;
        color: #eee
    }

</style>



// WEBPACK FOOTER //
// DateTimePickerTime.vue?bfa93a56